<template>
    <div class="">
      <button class="font-normal cursor-pointer order-last place-items-end inline-flex items-right px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-gray-600" @click="openModal()">{{ newButton ? newButton = newButton : '+ Add Campaign' }}</button>
      <ModalHeadlessUI ref="modal">
        <template #default>
          <h1 class="font-bold mb-4 text-3xl text-center">
            Add Campaign
          </h1>
          <div class="pt-4 pb-8 text-center">
            <p>
              Add Campaign then click edit to add automation steps.
            </p>
          </div>
          <form id="campaignForm" name="campaignForm" @submit.prevent="saveCampaign">
            <text-input v-model="campaignForm.name" :error="campaignForm.errors.name" class="pr-6 pb-4 w-full font-bold" label="Campaign Name" />
            <select-input v-model="campaignForm.target" :error="campaignForm.errors.target" class="pr-6 pb-4 w-full font-bold" label="Campaign Target">
              <option value="leads">Leads</option>
              <option value="contacts">Contacts</option>
            </select-input>
            <select-input v-model="campaignForm.start_time" :error="campaignForm.errors.start_time" class="pr-6 pb-4 w-full font-bold" label="Start Time">
              <option value="">None</option>
              <option v-for="hour in hours" :value="hour.value" :key="hour.value">{{ hour.label }}</option>
            </select-input>
            <select-input v-model="campaignForm.end_time" :error="campaignForm.errors.end_time" class="pr-6 pb-4 w-full font-bold" label="End Time">
              <option value="">None</option>
              <option v-for="hour in hours" :value="hour.value" :key="hour.value">{{ hour.label }}</option>
            </select-input>
            <div id="time_error" class="hidden form-error font-bold">Start time must be before end time.</div>
            <div class="grid lg:grid-cols-2 mt-4 mb-4">
              <div v-if="auth.owner" class="w-full lg:w-auto mb-4 ml-10">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input id="shared" v-model="campaignForm.shared" :true-value="1" :false-value="0" name="shared" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                    <label for="shared" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
                  </div>
                  <label for="automations">Shared Campaign</label>
              </div>
              
              <div class="w-full lg:w-auto mb-4 ml-10">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input id="remove_on_status_change" v-model="campaignForm.remove_on_status_change" :true-value="1" :false-value="0" name="remove_on_status_change" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                    <label for="remove_on_status_change" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
                  </div>
                  <label for="automations">Remove on Status Change</label>
              </div>
              
              <div class="w-full lg:w-auto mb-4 ml-10">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input id="send_on_weekends" v-model="campaignForm.send_on_weekends" :true-value="1" :false-value="0" name="send_on_weekends" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                    <label for="send_on_weekends" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
                  </div>
                  <label for="automations">Send on Weekends</label>
              </div>

              <div class="w-full lg:w-auto mb-4 ml-10">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input id="send_on_holidays" v-model="campaignForm.send_on_holidays" :true-value="1" :false-value="0" name="send_on_holidays" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                    <label for="send_on_holidays" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
                  </div>
                  <label for="automations">Send on Holidays</label>
              </div>

              <div class="w-full lg:w-auto mb-4 ml-10">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input id="stop_on_reply" v-model="campaignForm.stop_on_reply" :true-value="1" :false-value="0" name="stop_on_reply" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                    <label for="stop_on_reply" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
                  </div>
                  <label for="automations">Stop on Reply</label>
              </div>

            </div>

            <textarea-input v-model="campaignForm.description" class="pr-6 pb-4 w-full font-bold" rows="5" label="Description" :error="campaignForm.errors.description"  />
            <div class="tag-input w-full mb-5 min-w-full flex-row">
              <div class="flex justify-center items-center mt-4 min-w-full w-full">
                <div>
                  <loading-button :loading="campaignForm.processing" class="btn-indigo ml-auto" type="submit">Save Campaign</loading-button>
                </div>
              </div>
            </div>
          </form>
        </template>
      </ModalHeadlessUI>
    </div>
  </template>
  
  <script>
  import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import TextareaInput from '@/Shared/TextareaInput'
  import { router } from '@inertiajs/vue3'
  
  export default {
    components: {
      ModalHeadlessUI,
      SelectInput,
      TextInput,
      TextareaInput,
      LoadingButton,
    },
    props: {
    auth: Object,
      button: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        campaignForm: router.form({
          name: '',
          description: '',
          target: '',
          shared: false,
          start_time: '',
          end_time: '',
          send_on_weekends: false,
          send_on_holidays: false,
          stop_on_reply: false,
          remove_on_status_change: true,
        }),
        newButton: this.button,
      }
    },
      computed: {
        hours() {
          return Array.from({ length: 24 }, (_, index) => {
            const hour = index === 0 || index === 12 ? 12 : (index < 12 ? index : index - 12);
            const period = index < 12 ? 'AM' : 'PM';
            return {
              value: index,
              label: `${hour}:00 ${period}`,
            };
          });
        },
      },
    methods:{
      openModal() {
        this.$refs.modal.openModal()
      },
      closeModal() {
        this.$refs.modal.closeModal()
      },
      saveCampaign() {
        const startHour = parseInt(this.campaignForm.start_time);
        const endHour = parseInt(this.campaignForm.end_time);

        if (startHour >= endHour) {
          document.getElementById('time_error').classList.remove('hidden');
          return;
        }
        else{
          document.getElementById('time_error').classList.add('hidden');
        }

        var postTo = '/campaigns'
        this.campaignForm.post(postTo, {
          onSuccess: () => {
            const fieldsToReset = ['name', 'description', 'target', 'start_time', 'end_time', 'send_on_weekends', 'send_on_holidays', 'stop_on_reply'];
            fieldsToReset.forEach(field => this.campaignForm.reset(field));
            this.closeModal()
          },
        })
      },
    },
  }
  </script>
  <style>
    .tag-input {
      width: 100%;
      /* border: 1px solid #eee; */
      /* font-size: 0.9em; */
      height: 50px;
      box-sizing: border-box;
      padding: 0 10px;
      margin-right:25px;
    }
     .tag-input__tag {
      height: 30px;
      float: left;
      margin-right: 10px;
      /* background-color: #eee; */
      margin-top: 10px;
      line-height: 30px;
      padding: 0 5px;
      border-radius: 5px;
    }
    .tag-input__tag > span {
      cursor: pointer;
      opacity: 0.75;
    }
    /* CHECKBOX TOGGLE SWITCH */
    /* @apply rules for documentation, these do not work as inline style */
    .toggle-checkbox:checked {
      right: 0;
      border-color: #68D391;
    }
    .toggle-checkbox:checked + .toggle-label {
      background-color: #68D391;
    }
  </style>
  